export default "__VITE_ASSET__D_0n5Km2__"